import React, { Component } from 'react'
import { TABLA_CAMIONES_RECHAZADOS_ADMINISTRATIVAMENTE } from '../../../../../../config/tables'
import MuiTable from '../../../../../Forms/SharedComponents/containers/MuiTable'

export class TablaCamionesRechazadosAdministrativamenteView extends Component {
  render () {
    return (
      <MuiTable id={TABLA_CAMIONES_RECHAZADOS_ADMINISTRATIVAMENTE} />
    )
  }
}
